module.exports = __webpack_public_path__ + "002-trophy-1.34a76927.svg";